import { ItemViewModel } from '../ItemViewModel';
export class G_TagsViewModel{
    public Id :number
    public FK_Tag_Id:number
    public Name:string
    public Tags_Type:ItemViewModel
}